module.exports = __webpack_public_path__ + "media/40.8272d60a.mp3";